import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { z } from 'zod';

const rexListingRefreshFormSchema = z.object({
  agencyId: z.uuid({ error: 'Select an agency' }),
  listingId: z
    .string()
    .trim()
    .regex(/^\d+$/, 'Enter a positive REX listing ID')
    .refine(
      (value) => Number(value) > 0 && Number(value) <= 2147483647,
      'Enter a valid REX listing ID'
    ),
});

const rexListingRefreshFormDefinition = createFormDefinition({
  id: 'support-rex-listing-refresh',
  schema: rexListingRefreshFormSchema,
  fieldOrder: ['agencyId', 'listingId'],
  resolveFields: () => ({
    agencyId: { active: true, visible: true, disabled: false, required: true },
    listingId: { active: true, visible: true, disabled: false, required: true },
  }),
});

export const RexListingRefreshForm = createAgxForm(rexListingRefreshFormDefinition);
